import type { ChangeEventHandler } from "react";
import { useLocale, useSetLocale } from "../../contexts/Translation";
import { setCookie } from "../../lib/cookie";
import { WithInputProps } from "../../types";
import { Select } from "../Forms/Input";
import styles from "./LanguageSelector.module.css";

type LanguageSelectorProps = WithInputProps & {
  handleChange?: ChangeEventHandler<HTMLSelectElement>;
};

const languageOptions = [
  { value: "en", text: "English" },
  { value: "no", text: "Norsk" },
];

const LanguageSelector = ({ handleChange, label, name = "languageSelector", value }: LanguageSelectorProps) => {
  const { setLocale } = useSetLocale();
  const locale = useLocale();

  const changeLanguage: ChangeEventHandler<HTMLSelectElement> = (e) => {
    const nextLocale = e.target.value;
    setCookie("LANG", nextLocale);
    setLocale(nextLocale);
  };

  return (
    <Select
      className={styles.select}
      fieldClassName={styles.field}
      label={label}
      options={languageOptions}
      name={name}
      handleChange={handleChange || changeLanguage}
      value={value ? `${value}` : locale}
    />
  );
};

export default LanguageSelector;
